export default __webpack_public_path__ + "static/media/(43).122b1d57.jpg";